module.exports = __webpack_public_path__ + "carta.png?ace1507d002d9b4b805a9ff4520af857";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carta.png
// module id = 656
// module chunks = 0 2 7 8 9 10 17